import { Box, Typography } from "@mui/material";


const LessonCard = ({ data }) => {
    const date = new Date(data.date)
    const start = date.toLocaleTimeString().slice(0, 5)

    const endDate = new Date(date.getTime() + data.duration * 60000)
    const end = endDate.toLocaleTimeString().slice(0, 5)

    return <Box sx={{
        minWidth: { sm: 150, xs: "100%" },
        maxWidth: "100%",
        p: 1,
        borderBottom: 1,
        borderColor: "#ccc"
    }}>

        <Typography align="center" fontWeight="bold" fontSize={13} noWrap>
            {data.subject_name}
        </Typography>

        <Typography align="center" fontSize={11} noWrap>
            {data.studio_name}
        </Typography>

        <Typography align="center" fontSize={11}>
            {data.group_name}
        </Typography>
        <Typography align="center" fontSize={11}>
            {start} - {end}
        </Typography>
    </Box>
}

export default LessonCard